module.exports = __parcel__import__.meta.resolve("8k9jx");